import { action } from 'satcheljs';

export const clickTodo = action('clickTodo', (itemId: string) => ({
    itemId,
}));

export const updateIsEditing = action('updateIsEditing', (itemId: string, isEditing: boolean) => ({
    itemId,
    isEditing,
}));

export const enterTodo = action('enterTodo', () => ({}));
